export const visibleMeasurementsForSlice = (measurements = [], slice = 0, pendingMeasure = null) => [
  ...measurements.filter(m => m?.slice === slice),
  ...(pendingMeasure ? [{ ...pendingMeasure, id: 'pending', color: '#ffeb3b', pending: true }] : []),
];

export const visibleRoisForSlice = (rois = [], slice = 0, pendingRoi = null) => [
  ...rois.filter(r => r?.slice === slice),
  ...(pendingRoi ? [{ ...pendingRoi, id: 'pending-roi', pending: true }] : []),
];

export const visibleAnnotationsForSlice = (annotations = [], slice = 0) => annotations.filter(a => a?.slice === slice);
